module.exports = __webpack_public_path__ + "img/38_60.1db5d255.png";